import api from './api';

export interface AboutVideo {
  id?: number;
  title: string;
  youtube_link: string;
  is_active: boolean;
  display_order: number;
  created_at?: string;
  updated_at?: string;
}

export interface AboutVideoPublic {
  title: string;
  youtube_link: string;
}

export interface PaginatedAboutVideoResponse {
  videos: AboutVideo[];
  total: number;
  page: number;
  per_page: number;
  pages: number;
}

export const aboutVideoService = {
  getActiveVideos: async (): Promise<AboutVideoPublic[]> => {
    const response = await api.get<{ videos: AboutVideoPublic[] }>('/about-videos/public/active');
    return response.data.videos;
  },

  list: async (params?: {
    page?: number;
    per_page?: number;
    is_active?: string;
  }): Promise<PaginatedAboutVideoResponse> => {
    const response = await api.get<PaginatedAboutVideoResponse>('/about-videos/admin/list', {
      params,
    });
    return response.data;
  },

  create: async (data: Partial<AboutVideo>): Promise<AboutVideo> => {
    const response = await api.post<{ message: string; video: AboutVideo }>(
      '/about-videos/admin/create',
      data
    );
    return response.data.video;
  },

  update: async (id: number, data: Partial<AboutVideo>): Promise<AboutVideo> => {
    const response = await api.put<{ message: string; video: AboutVideo }>(
      `/about-videos/admin/${id}`,
      data
    );
    return response.data.video;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/about-videos/admin/${id}`);
  },
};






